import React, { useState, useEffect, useContext } from "react"
import { Container, Typography, Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, TextField } from '@material-ui/core';
import { ArrowUpward, ArrowDownward, Search, Clear } from "@material-ui/icons"
import { useHistory } from "react-router";
import { Search_Panel } from './../components/Work_SearchPanel/index'
import { workAPI } from "./../services/WorkService"
import Swal from "sweetalert2";
import moment from 'moment';
import { AppContext } from "./../contexts/appContext"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import Download from "downloadjs"
import { NoIpadDevice } from "../utils/config";

const Work = (props) => {
    let history = useHistory()
    const { user } = useContext(AppContext)
    const [startDate, setStartDate] = useState(moment().startOf('month').toDate());
    const [endDate, setEndDate] = useState(moment(startDate).endOf('month').toDate());
    const [type, setType] = useState([]);
    const [SelectType, setSelectType] = useState(null);
    const [data, setData] = useState([])
    const [force, setForce] = useState(0);
    const [searchText, setSearchText] = useState("")
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [filterData, setFilterData] = useState(null)
    const [sortBy, setSortBy] = useState("status")
    const [sortOrder, setSortOrder] = useState("asc")
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setrowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useEffect(() => {
        document.title = 'Com7 Merchandise - Report 1on1'
        if (user) {
            workAPI.reportByWork({ date_start: startDate, date_end: endDate })
                .then((res) => {
                    if (res.status == 200) {
                        if (Array.isArray(res.message)) {
                            setData(res.message)
                            let type_fromdata = res.message.reduce((prev, curr) => {
                                let find_dup_type = prev.find((res) => res.value == curr.type)
                                if (!find_dup_type) {
                                    prev.push({ value: curr.type, label: curr.type })
                                }
                                return prev
                            }, [])
                            setType(type_fromdata)
                            setSelectType(null)
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">API DATA is not Array</span>`,
                                backdrop: 'transparent',
                                background: 'rgba(0,0,0,.75)',
                                customClass: {
                                    icon: 'switch'
                                },
                                width: '28rem',
                                timer: 5000
                            }).then(() => {
                                setForce((old) => old + 1)
                            })
                        }
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">Something Wrong!!!</span>`,
                            backdrop: 'transparent',
                            background: 'rgba(0,0,0,.75)',
                            customClass: {
                                icon: 'switch'
                            },
                            width: '28rem',
                            timer: 5000
                        }).then(() => {
                            setForce((old) => old + 1)
                        })
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 5000
                    }).then(() => {
                        setForce((old) => old + 1)
                    })
                })
        }
    }, [user, force, startDate, endDate])

    const statusChange = (status) => {
        switch (status) {
            case "New": return "New"
            case "Pending": return "On Process"
            case "Accept": return "Close"
            default: return status

        }
    }

    const filterCondition = (res) => {
        let concat_string = `${res?.title}`.concat(res.fullname, statusChange(res.status), res.type, res.createdAt, res.fullname2, res.id_created, res.updatedAt)
        if (searchText != "" && SelectType) return concat_string.toLowerCase().includes(searchText.toLowerCase()) && res.type == SelectType
        if (searchText != "" && !SelectType) return concat_string.toLowerCase().includes(searchText.toLowerCase())
        if (searchText == "" && SelectType) return res.type == SelectType
        else return true
    }

    let searchProps = { startDate, setStartDate, endDate, setEndDate, type, SelectType, setSelectType }

    const caseWork = (params) => {
        switch (params) {
            case "New": return Number(1);
            case "Pending": return Number(2);
            case "Accept": return Number(3);
            case "Decline": return Number(4);
            default: return params;
        }
    }

    const sortData = () => {
        let compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {
                    if (moment(i[sortBy]).valueOf() < moment(j[sortBy]).valueOf()) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (moment(i[sortBy]).valueOf() > moment(j[sortBy]).valueOf()) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                }
                break;
            case "updatedAt":
                compareFn = (i, j) => {
                    if (moment(i[sortBy]).valueOf() < moment(j[sortBy]).valueOf()) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (moment(i[sortBy]).valueOf() > moment(j[sortBy]).valueOf()) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                }
                break;
            case "status":
                compareFn = (i, j) => {
                    if (Number(caseWork(i[sortBy])) < Number(caseWork(j[sortBy]))) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (Number(caseWork(i[sortBy])) > Number(caseWork(j[sortBy]))) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                };
                break;
            default: compareFn = (i, j) => {
                if (i[sortBy] < j[sortBy]) {
                    return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                } else {
                    if (i[sortBy] > j[sortBy]) {
                        return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                    } else {
                        return 0;
                    }
                }
            }
        }
        return compareFn;
    }
    const deleteLastnameandEIEI = (name) => {
        let cut = name.split(" ")
        cut = cut[0]
        cut = cut.replace("นาย", "")
        cut = cut.replace("นางสาว", "")
        cut = cut.replace("นาง", "")
        cut = cut.trim()
        return cut
    }

    const changeSortable = (name) => {
        if (name == sortBy) {
            if (sortOrder == "asc") {
                setSortOrder("desc")
            }
            else if (sortOrder == "desc") {
                setSortOrder("")
                setSortBy("")
            }
            else {
                setSortOrder("asc")
            }
        }
        else {
            setSortOrder("asc")
        }
    }

    const requestSearch = (searchValue) => {
        setSearchText(searchValue);
    };

    const Filter = data.filter(filterCondition)

    const filterStatus = (res) => {
        if (filterData) return filterData == res.status
        else return true
    }

    const statusColorCheck = (status) => {
        if (status == "New") return { border: '1px solid transparent ', borderRadius: '10px', textAlign: 'center', color: '#fff', fontWeight: 'bold', backgroundColor: 'rgb(255, 105, 97)' }
        else if (status == "Pending") return { border: '1px solid transparent ', borderRadius: '10px', textAlign: 'center', color: 'black', fontWeight: 'bold', backgroundColor: 'rgb(253, 253, 150)' }
        else if (status == "Accept") return { border: '1px solid transparent ', borderRadius: '10px', textAlign: 'center', color: '#fff', fontWeight: 'bold', backgroundColor: 'rgb(119, 221, 144)' }
        else if (status == "Decline") return { border: '1px solid transparent ', borderRadius: '10px', textAlign: 'center', color: 'black', fontWeight: 'bold', backgroundColor: 'rgb(204, 204, 204)' }
        else return {}
    }

    const secondsToDhms = (minutes) => {
        let seconds = Number(minutes) * 60;
        let d = Math.floor(seconds / (3600 * 24));
        let h = Math.floor(seconds % (3600 * 24) / 3600);
        let m = Math.floor(seconds % 3600 / 60);
        let s = Math.floor(seconds % 60);
        let dDisplay = d > 0 ? d + " วัน " : "";
        let hDisplay = h > 0 ? h + " ชั่วโมง " : "";
        let mDisplay = m > 0 ? m + " นาที " : "";
        let sDisplay = s > 0 ? s + " วินาที" : "";
        return dDisplay + hDisplay + mDisplay + sDisplay;
    }

    const Export_Excel = () => {
        Swal.fire({
            title: 'คุณแน่ใจ ?',
            text: "ต้องการ Export ข้อมูลใช่หรือไม่ ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#56A834',
            cancelButtonColor: 'red',
            denyButtonColor: '#d33',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ยกเลิก',
        }).then((result) => {

            if (result.isConfirmed) {
                workAPI.ExportExceloneOnone({ date_start: startDate, date_end: endDate })
                    .then((response) => {
                        if (response.status == 200) {
                            Download(response.data, `Report_Merchandise_1on1 - ${moment().format("DD-MM-YYYY HH-mm-ss")}.xlsx`, response.headers['content-type'])
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${response.message}</span>`,
                                timer: 3000
                            })
                        }
                    })
            }
        })
    }

    return (
        user && <React.Fragment>
            {NoIpadDevice ? <Container style={{ paddingLeft: '0', paddingRight: '0' }}>
                <Typography component="div" style={{ backgroundColor: '#ffffffe6', borderRadius: '15px', height: '93vh' }}>
                    <Container style={{ marginTop: '10px', height: '5%', }}>
                        <span style={{ fontSize: "1.5em", fontWeight: 'bold', cursor: 'pointer' }} >
                            Report by Work
                        </span>
                    </Container>
                    <Container style={{ padding: '25px', borderBottom: '2px solid lightgray' }}>
                        <div className="summaryzz">
                            <div className="titles">
                                <div style={{ marginRight: 'auto' }}>
                                    <Button style={{ textTransform: 'none' }}
                                        onClick={() => setFilterData(null)} className="clearBTN">Clear filter</Button>
                                </div>
                            </div>
                            <div className="lB">
                                <div className="dataBox"
                                    style={{ backgroundColor: 'rgb(255, 105, 97)', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{
                                            color: '#fff',
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        className="BTNControl"
                                        onClick={() => { setFilterData("New") }}>
                                        New : {Filter?.filter((res) => res.status == "New").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(253, 253, 150)', }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Pending") }}>
                                        On Process : {Filter?.filter((res) => res.status == "Pending").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(119, 221, 144)' }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            color: '#fff',
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Accept") }}>
                                        Close : {Filter?.filter((res) => res.status == "Accept").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(204, 204, 204)' }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Decline") }}>
                                        Decline : {Filter?.filter((res) => res.status == "Decline").length}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <Box style={{ margin: 'auto 0' }} color="primary.main">
                            <Search_Panel data={data} {...searchProps} />
                        </Box>
                    </Container>
                    <div style={{ padding: '10px' }}>
                        <div className="flex-container ">
                            <div style={{ marginRight: 'auto' }}>
                                <TextField
                                    style={{ marginRight: 'auto', justifyContent: 'flex-end' }}
                                    variant="standard"
                                    value={searchText}
                                    onChange={(event) => requestSearch(event.target.value)}
                                    placeholder="Search…"
                                    InputProps={{
                                        startAdornment: <Search fontSize="small" />,
                                        endAdornment: (
                                            <IconButton
                                                title="Clear"
                                                aria-label="Clear"
                                                size="small"
                                                style={{ visibility: searchText != '' ? 'visible' : 'hidden' }}
                                                onClick={() => requestSearch('')}
                                            >
                                                <Clear fontSize="small" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </div>
                            <div style={{ marginLeft: 'auto' }}>
                                <Button
                                    variant='contained'
                                    style={{ backgroundColor: "#6ab23a", color: 'whitesmoke', whiteSpace: 'nowrap', textTransform: 'none' }}
                                    size="small"
                                    onClick={Export_Excel}
                                >
                                    Export<FontAwesomeIcon style={{ marginLeft: '5px' }} icon={faFileExcel} size="lg" />
                                </Button>
                            </div>
                        </div>
                        <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '2%', display: data.length == 0 ? 'none' : 'block' }}>
                            <Table className="ayLmao">
                                <TableHead className="heheXd"
                                    style={{
                                        height: '50px',
                                        position: "sticky",
                                        textAlign: 'center'
                                    }}>
                                    <TableRow >
                                        <TableCell onClick={() => { setSortBy("id"); changeSortable("id") }}>Create ID</TableCell>
                                        <TableCell onClick={() => { setSortBy("type"); changeSortable("type") }}>Type
                                            {sortBy == "type" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "type" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("title"); changeSortable("title") }}>Title
                                            {sortBy == "title" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "title" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("status"); changeSortable("status") }}>Status
                                            {sortBy == "status" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "status" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("fullname"); changeSortable("fullname") }}>Create Name
                                            {sortBy == "fullname" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "fullname" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("createdAt"); changeSortable("createdAt") }}>Create Date
                                            {sortBy == "createdAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "createdAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("fullname2"); changeSortable("fullname") }}>Support Name
                                            {sortBy == "fullname" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "fullname" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("updatedAt"); changeSortable("updatedAt") }}>Update Date
                                            {sortBy == "updatedAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "updatedAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("updatedAt"); changeSortable("updatedAt") }}>วันที่รับงาน
                                            {sortBy == "updatedAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "updatedAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("total_time"); changeSortable("total_time") }}>เวลาที่ทำเกิน
                                            {sortBy == "total_time" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "total_time" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ textAlign: 'center' }}>
                                    {Filter.filter(filterStatus).sort(sortData()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((res, i) => (
                                        <TableRow key={i} className="mouseEvent" onClick={() => history.push(`detail-work/${res._id}`)}>
                                            <TableCell>{res.id_created}</TableCell>
                                            <TableCell>{res.type}</TableCell>
                                            <TableCell>{res.title}</TableCell>
                                            <TableCell><div style={statusColorCheck(res.status)}>{statusChange(res.status)} </div></TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{deleteLastnameandEIEI(res.fullname)}</TableCell>
                                            <TableCell>{moment(res.createdAt).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{res.fullname2 ? deleteLastnameandEIEI(res.fullname2) : "-"}</TableCell>
                                            <TableCell>{moment(res.updatedAt).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell>{!res.assitDate ? "-" : moment(res.assitDate).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell>{res.total_time < 0 ? "-" : secondsToDhms(res.total_time)}</TableCell>
                                        </TableRow>
                                    ))
                                    }
                                </TableBody>


                            </Table>
                        </TableContainer>
                        {data.length > 10 && <TablePagination
                            rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: 'All', value: data.filter(filterCondition).length },
                            ].filter((res) => res != data.filter(filterCondition).length)}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            component="div"
                            count={data.filter(filterCondition).length}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />}
                    </div>
                </Typography>
            </Container> : <div style={{ paddingLeft: '50px', paddingRight: '50px' }}>
                <Typography component="div" style={{ backgroundColor: '#ffffffe6', borderRadius: '15px', height: '93vh' }}>
                    <Container style={{ marginTop: '10px', height: '5%', }}>
                        <span style={{ fontSize: "1.5em", fontWeight: 'bold', cursor: 'pointer' }} >
                            Report by Work
                        </span>
                    </Container>
                    <Container style={{ padding: '25px', borderBottom: '2px solid lightgray' }}>
                        <div className="summaryzz">
                            <div className="titles">
                                <div style={{ marginRight: 'auto' }}>
                                    <Button style={{ textTransform: 'none' }}
                                        onClick={() => setFilterData(null)} className="clearBTN">Clear filter</Button>
                                </div>
                            </div>
                            <div className="lB">
                                <div className="dataBox"
                                    style={{ backgroundColor: 'rgb(255, 105, 97)', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{
                                            color: '#fff',
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        className="BTNControl"
                                        onClick={() => { setFilterData("New") }}>
                                        New : {Filter?.filter((res) => res.status == "New").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(253, 253, 150)', }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Pending") }}>
                                        On Process : {Filter?.filter((res) => res.status == "Pending").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(119, 221, 144)' }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            color: '#fff',
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Accept") }}>
                                        Close : {Filter?.filter((res) => res.status == "Accept").length}
                                    </Button>
                                </div>
                                <div className="dataBox" style={{ backgroundColor: 'rgb(204, 204, 204)' }}>
                                    <Button
                                        className="BTNControl"
                                        style={{
                                            fontSize: "120%",
                                            fontWeight: 'bold',
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: '15px',
                                            textTransform: 'none'
                                        }}
                                        onClick={() => { setFilterData("Decline") }}>
                                        Decline : {Filter?.filter((res) => res.status == "Decline").length}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <Box style={{ margin: 'auto 0' }} color="primary.main">
                            <Search_Panel data={data} {...searchProps} />
                        </Box>
                    </Container>
                    <div style={{ padding: '10px' }}>
                        <div className="flex-container ">
                            <div style={{ marginRight: 'auto' }}>
                                <TextField
                                    style={{ marginRight: 'auto', justifyContent: 'flex-end' }}
                                    variant="standard"
                                    value={searchText}
                                    onChange={(event) => requestSearch(event.target.value)}
                                    placeholder="Search…"
                                    InputProps={{
                                        startAdornment: <Search fontSize="small" />,
                                        endAdornment: (
                                            <IconButton
                                                title="Clear"
                                                aria-label="Clear"
                                                size="small"
                                                style={{ visibility: searchText != '' ? 'visible' : 'hidden' }}
                                                onClick={() => requestSearch('')}
                                            >
                                                <Clear fontSize="small" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </div>
                            <div style={{ marginLeft: 'auto' }}>
                                <Button
                                    variant='contained'
                                    style={{ backgroundColor: "#6ab23a", color: 'whitesmoke', whiteSpace: 'nowrap', textTransform: 'none' }}
                                    size="small"
                                    onClick={Export_Excel}
                                >
                                    Export<FontAwesomeIcon style={{ marginLeft: '5px' }} icon={faFileExcel} size="lg" />
                                </Button>
                            </div>
                        </div>
                        <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '2%', display: data.length == 0 ? 'none' : 'block' }}>
                            <Table className="ayLmao">
                                <TableHead className="heheXd"
                                    style={{
                                        height: '50px',
                                        position: "sticky",
                                        textAlign: 'center'
                                    }}>
                                    <TableRow >
                                        <TableCell onClick={() => { setSortBy("id"); changeSortable("id") }}>Create ID</TableCell>
                                        <TableCell onClick={() => { setSortBy("type"); changeSortable("type") }}>Type
                                            {sortBy == "type" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "type" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("title"); changeSortable("title") }}>Title
                                            {sortBy == "title" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "title" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("status"); changeSortable("status") }}>Status
                                            {sortBy == "status" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "status" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("fullname"); changeSortable("fullname") }}>Create Name
                                            {sortBy == "fullname" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "fullname" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("createdAt"); changeSortable("createdAt") }}>Create Date
                                            {sortBy == "createdAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "createdAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("fullname2"); changeSortable("fullname") }}>Support Name
                                            {sortBy == "fullname" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "fullname" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("updatedAt"); changeSortable("updatedAt") }}>Update Date
                                            {sortBy == "updatedAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "updatedAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("updatedAt"); changeSortable("updatedAt") }}>วันที่รับงาน
                                            {sortBy == "updatedAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "updatedAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                        <TableCell onClick={() => { setSortBy("total_time"); changeSortable("total_time") }}>เวลาที่ทำเกิน
                                            {sortBy == "total_time" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "total_time" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ textAlign: 'center' }}>
                                    {Filter.filter(filterStatus).sort(sortData()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((res, i) => (
                                        <TableRow key={i} className="mouseEvent" onClick={() => history.push(`detail-work/${res._id}`)}>
                                            <TableCell>{res.id_created}</TableCell>
                                            <TableCell>{res.type}</TableCell>
                                            <TableCell>{res.title}</TableCell>
                                            <TableCell><div style={statusColorCheck(res.status)}>{statusChange(res.status)} </div></TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{deleteLastnameandEIEI(res.fullname)}</TableCell>
                                            <TableCell>{moment(res.createdAt).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{res.fullname2 ? deleteLastnameandEIEI(res.fullname2) : "-"}</TableCell>
                                            <TableCell>{moment(res.updatedAt).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell>{!res.assitDate ? "-" : moment(res.assitDate).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                            <TableCell>{res.total_time < 0 ? "-" : secondsToDhms(res.total_time)}</TableCell>
                                        </TableRow>
                                    ))
                                    }
                                </TableBody>


                            </Table>
                        </TableContainer>
                        {data.length > 10 && <TablePagination
                            rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: 'All', value: data.filter(filterCondition).length },
                            ].filter((res) => res != data.filter(filterCondition).length)}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            component="div"
                            count={data.filter(filterCondition).length}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />}
                    </div>
                </Typography>
            </div>}
        </React.Fragment>
    )
}

export default Work